import React from 'react';

interface IMapIconProps {
	size?: string;
}

export const MapIcon = ({ size = '24' }: IMapIconProps) => {
	return (
		<svg role="img" width={size} height={size} viewBox="0 0 24 24" fill="none" aria-labelledby="loaderIcon">
			<title id="loaderIcon">map icon</title>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.34 3H20.5C20.7761 3 21 3.22386 21 3.5V18.62C21 18.85 20.85 19 20.64 19.1L15 21L9 18.9L3.66 20.97C3.61 21 3.55 21 3.5 21C3.22386 21 3 20.7761 3 20.5V5.38C3 5.15 3.15 4.97 3.36 4.9L9 3L15 5.1L20.34 3ZM9 16.89L15 19V7.11L9 5V16.89Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
